import type { InputHTMLAttributes } from 'react';

import { cn } from '../../lib/utils';

export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={cn(
        'h-11 w-full rounded-lg border bg-surface px-3 text-base text-foreground',
        'placeholder:text-muted focus-visible:border-accent',
        className,
      )}
      {...props}
    />
  );
}
